import { QRCodeCanvas } from "qrcode.react";
import { toast } from "sonner";
import { Copy, Share2, ArrowDownLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { PageHeader } from "../components/common";

export default function Receive() {
  const { user } = useAuth();
  const payUrl = `${window.location.origin}/?pay=${encodeURIComponent(user.cash_tag)}`;

  const copy = () => { navigator.clipboard.writeText(user.cash_tag); toast.success("Cash Tag copied"); };
  const share = async () => {
    const data = { title: "Pay me on Jack Cash", text: `Send me money on Jack Cash: ${user.cash_tag}`, url: payUrl };
    try {
      if (navigator.share) await navigator.share(data);
      else { navigator.clipboard.writeText(payUrl); toast.success("Share link copied"); }
    } catch {}
  };

  return (
    <div className="animate-fade-up">
      <PageHeader title="Receive Money" subtitle="Share your Cash Tag or QR code" />

      <div className="rounded-3xl p-7 text-white text-center shadow-[0_18px_44px_rgba(75,35,204,0.35)] mb-6"
        style={{ background: "linear-gradient(135deg,#6B3BF5,#4B23CC)" }}>
        <div className="inline-grid place-items-center w-12 h-12 rounded-2xl bg-white/15 mb-3">
          <ArrowDownLeft size={24} />
        </div>
        <p className="text-white/70 text-xs tracking-[0.18em] uppercase font-semibold">Your Cash Tag</p>
        <div data-testid="receive-cashtag" className="font-display text-3xl font-semibold mt-1 font-mono">{user.cash_tag}</div>
      </div>

      <div className="rounded-3xl bg-card border border-border p-7 flex flex-col items-center">
        <div className="bg-white p-4 rounded-2xl" data-testid="receive-qr">
          <QRCodeCanvas value={payUrl} size={196} fgColor="#4B23CC" level="M" />
        </div>
        <p className="text-sm text-muted-foreground mt-4 text-center">Scan to pay {user.display_name} instantly.</p>
      </div>

      <div className="grid grid-cols-2 gap-3 mt-6">
        <button data-testid="receive-copy-btn" onClick={copy}
          className="h-14 rounded-2xl bg-secondary font-semibold flex items-center justify-center gap-2 transition-transform duration-200 active:scale-95">
          <Copy size={18} /> Copy
        </button>
        <button data-testid="receive-share-btn" onClick={share}
          className="h-14 rounded-2xl bg-primary text-primary-foreground font-semibold flex items-center justify-center gap-2 transition-transform duration-200 active:scale-95">
          <Share2 size={18} /> Share
        </button>
      </div>
    </div>
  );
}
